__webpack_require__.p = "https://bundle.stayforlong.com/20260107.4/_next/";